import {ReasonCards} from '@/components/common/reason-cards-v2/ReasonCards';
import {Section, SECTION_STYLES} from '@/components/common/section/Section';
import {Title} from '@/components/common/title/Title';

import {data} from './const';
import styles from './SurveyUsers.module.css';

export function SurveyUsers() {
	return (
		<Section style={SECTION_STYLES.WITH_BREAKPOINTS} className={styles.root}>
			<Title with1680={false} className={styles.title}>
				Кому будет полезен сервис
			</Title>
			<ReasonCards list={data} className={styles.content} />
		</Section>
	);
}
